import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'

export const LinkStyled = styled(Link)`
  display: flex;
  align-items: flex-start;
  ${({ theme }) => theme.transition};
  fill: ${({ theme }) => theme.color.textDarker};
  transform: translateZ(0);

  &::before {
    content: 'beta';
    color: ${({ theme }) => theme.color.background};
    background: ${({ theme }) => theme.color.primaryDarker};
    padding: 0 4px;
    margin-right: 4px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    top: 0;
    left: 0;
    transform: translate(0, -50%) rotate(-30deg);
  }

  &:hover {
    opacity: 0.8;
  }
`
